import React from 'react';
import { Text, View } from '@react-pdf/renderer';

const Header = ({ text }: any) => {
  return (
    <View fixed style={{
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      fontSize: 9
    }}>
      <Text>{text}</Text>
      <Text>{new Date().toLocaleDateString()}</Text>
    </View>
  )
}

export default Header
